import { Link } from "@/components/link";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { PATH_ROOT } from "@/constants";
import { CircleChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function StepAuthorizedSuccess() {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4">
      <Alert variant="success">
        <AlertTitle>
          {t("resetPassword.passwordChangedForAuthorizedUserTitle")}
        </AlertTitle>
        <AlertDescription>
          {t("resetPassword.passwordChangedForAuthorizedUserDescription")}
        </AlertDescription>
      </Alert>
      <footer>
        <Link to={PATH_ROOT} icon={CircleChevronLeft} className="pl-0">
          {t("resetPassword.backToMainPage")}
        </Link>
      </footer>
    </div>
  );
}
